import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { BRAND_NAME, BRAND_SUFFIX } from './config';
import { setLocale } from './i18n';
import { installErrorBuffer } from './lib/clientErrors';
import { queryClient } from './lib/queryClient';
import './index.css';
import './stores/theme';

setLocale('uk');
installErrorBuffer();
document.title = `${BRAND_NAME} ${BRAND_SUFFIX}`;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
